var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipsisActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "#FFD9CB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 13C21.3806 13 22.4999 11.8807 22.4999 10.5C22.4999 9.11929 21.3806 8 19.9999 8C18.6192 8 17.4999 9.11929 17.4999 10.5C17.4999 11.8807 18.6192 13 19.9999 13Z",
    fill: "#E84C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 22.4995C21.3806 22.4995 22.4999 21.3802 22.4999 19.9995C22.4999 18.6188 21.3806 17.4995 19.9999 17.4995C18.6192 17.4995 17.4999 18.6188 17.4999 19.9995C17.4999 21.3802 18.6192 22.4995 19.9999 22.4995Z",
    fill: "#E84C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 32.0005C21.3806 32.0005 22.4999 30.8812 22.4999 29.5005C22.4999 28.1198 21.3806 27.0005 19.9999 27.0005C18.6192 27.0005 17.4999 28.1198 17.4999 29.5005C17.4999 30.8812 18.6192 32.0005 19.9999 32.0005Z",
    fill: "#E84C25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisActiveIcon);
export default __webpack_public_path__ + "static/media/ellipsis-active-icon.58594c868b4affa288468a395a806f7a.svg";
export { ForwardRef as ReactComponent };